var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 24.02C18.6276 24.02 24 18.6476 24 12.02C24 5.39242 18.6276 0.0200195 12 0.0200195C5.3724 0.0200195 0 5.39242 0 12.02C0 18.6476 5.3724 24.02 12 24.02Z","fill":"#0BC5EA","key":0}),React.createElement("path",{"d":"M6.56934 12.7959L9.67255 15.8992L17.4306 8.14111","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircle.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
